import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '../../../utils/analytics/analytics';
import { routes } from '../../../config/routes/routes';

export const PageTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // The thank-you page sends its own pageview, and only for a paid order -
    // a refresh or a typed-in URL must not count as one more conversion.
    if (location.pathname === routes.orderSuccess) {
      return;
    }

    trackPageview(location.pathname + location.search);
  }, [location]);

  return null;
};

export default PageTracker;
